const mixinComponent = {
  props: {
    value: {type: [String, Number], default: ''},
    dataState: {type: String, default: $CONST_STRING.DATA_STATE_INITIALIZING}, // 数据状态，initing表示在初始化中，inited之后开始进行校验，对比
    fieldKey: {type: String, default: ''}, // 当前字段的key
    patterns: {type: Array, default: () => []}, // 正则表达式数组
    novalid: {type: Boolean, default: false}, // 不校验标志
  },
  data () {
    return {
      originValue: null,
      innerPatterns: [],
    }
  },
  computed: {
    // 不校验标识
    currentNovalid () {
      // 当不校验标识为true，隐藏，只读，不可用时候，不校验
      return this.novalid || this.hide || this.readonly || this.disabled
    },
    needValid () {
      // 目的是任一变量发生变化，该变量也会发生变化
      // 返回字符串，任一变量改变都会导致整个字符串变化
      if(process.env.log === 'valid' || process.env.log === 'all') { console.log('needValid变化') }
      return this.dataState === $CONST_STRING.DATA_STATE_INITIALIZED
        ? `${this.novalid}${this.hide}${this.readonly}${this.disabled}${this.required}${this.value}`
        : undefined
    },
  },
  watch: {
    dataState: {
      handler (newValue) {
        if(newValue === $CONST_STRING.DATA_STATE_INITIALIZED) {
          if(process.env.log === 'valid' || process.env.log === 'all') { console.log('watch  dataState  变化', this.value) }
          // 当初始化完成时，存储原始值，以便和value对比，该字段是否发生了变化
          this.originValue = this.value
        }
      },
    },
    value: {
      handler (newValue) {
        // eslint-disable-next-line
        if (this.originValue != newValue) {
          // todo 故意用!=，原因是只比较值，不管是不是同一类型
          // 当前值与原始值不相同时候，触发save事件，将父组件的saveList的fieldKey对应的值设置为newValue
          this.$emit('save', this.fieldKey, newValue)
          if(process.env.log === 'save' || process.env.log === 'all') {
            console.log(
              '当前值与原始值不相同时候，触发save事件，将父组件的saveList的fieldKey对应的值设置为newValue',
              this.originValue,
              newValue
            )
          }
        } else {
          // 当前值与原始值相同时候，触发save事件，将父组件的saveList的fieldKey对应的值设置为undefined
          this.$emit('save', this.fieldKey, undefined)
          if(process.env.log === 'save' || process.env.log === 'all') {
            console.log(
              '当前值与原始值相同时候，触发save事件，将父组件的saveList的fieldKey对应的值设置为undefined',
              this.originValue,
              newValue
            )
          }
        }
        // if(this.dataState === $CONST_STRING.DATA_STATE_INITIALIZED) {
        //   // eslint-disable-next-line
        //   if (this.originValue != newValue) {
        //     // todo 故意用!=，原因是只比较值，不管是不是同一类型
        //     // 当前值与原始值不相同时候，触发save事件，将父组件的saveList的fieldKey对应的值设置为newValue
        //     this.$emit('save', this.fieldKey, newValue)
        //     if(process.env.log === 'save' || process.env.log === 'all') {
        //       console.log(
        //         '当前值与原始值不相同时候，触发save事件，将父组件的saveList的fieldKey对应的值设置为newValue',
        //         this.originValue,
        //         newValue
        //       )
        //     }
        //   } else {
        //     // 当前值与原始值相同时候，触发save事件，将父组件的saveList的fieldKey对应的值设置为undefined
        //     this.$emit('save', this.fieldKey, undefined)
        //     if(process.env.log === 'save' || process.env.log === 'all') {
        //       console.log(
        //         '当前值与原始值相同时候，触发save事件，将父组件的saveList的fieldKey对应的值设置为undefined',
        //         this.originValue,
        //         newValue
        //       )
        //     }
        //   }
        // }
      },
    },
    needValid: {
      handler (newValue, oldValue) {
        if(process.env.log === 'valid' || process.env.log === 'all') { console.log('watch  needValid  变化', newValue, oldValue) }
        // needValid标志变化时，对该字段进行校验
        this.$emit('valid', this.fieldKey, this.valid(this.value))
      },
      immediate: true, // 进入编辑页面需要这个属性才会触发handler
    },
  },
  methods: {
    /**
     * @method valid
     * @param {String} - 需要校验的值
     * @returns {Object | undefined} - 错误Object，undefined
     * @description - 如果校验出现错误，返回错误Object，包含message属性，如果不校验或者校验通过，返回undefined
     */
    valid (newValue) {
      if(this.currentNovalid) return undefined
      if(this.required && !newValue && newValue !== false) { return {message: `${this.title}必填哦`} }
      if(this.patterns) {
        for(const item of this.patterns) {
          const pattern = new RegExp(item.pattern)
          /* newValue要有值才进行pattern校验，不然会出现特殊情况，pattern要求十一位数字，而且字段不是必填，
          但是会出现不填写不能通过pattern校验的情况，进而隐形地约束了字段的必填，超出了它的校验范围，
          如果字段是必填的话，会先进行required校验，没有值是不能通过required校验的，也就不会进行pattern校验
          */
          if(process.env.log === 'pattern' || process.env.log === 'all') { console.log(pattern.test(newValue), pattern) }
          if(newValue && !pattern.test(newValue)) { return {message: item.message} }
        }
      }
      if(this.innerPatterns) {
        for(const item of this.innerPatterns) {
          const pattern = new RegExp(item.pattern)
          /* newValue要有值才进行pattern校验，不然会出现特殊情况，pattern要求十一位数字，而且字段不是必填，
          但是会出现不填写不能通过pattern校验的情况，进而隐形地约束了字段的必填，超出了它的校验范围，
          如果字段是必填的话，会先进行required校验，没有值是不能通过required校验的，也就不会进行pattern校验
          */
          if(newValue && !pattern.test(newValue)) { return {message: item.message} }
        }
      }
      return undefined
    },
  },
}

export default mixinComponent



// WEBPACK FOOTER //
// ./src/components/basic/mixinComponent.js